
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import * as Rx from 'rxjs';
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/lib/services/common-service'
import { CreatorList } from 'src/lib/entity/live';

@Component({
  selector: 'creator-index',
  templateUrl: './creator-index.component.html',
  styleUrls: ['./creator-index.component.scss', '../../../../pages/admin/startbootstrap-sb-admin-gh-pages/src/scss/styles.scss']
})
export class CreatorIndexComponent implements OnInit {
  /** ページネーション関係 */
  private maxDisplayPage: number = 5;
  private beginingStartPage: number = 2;
  maxDisplayCount: number = 10;
  currentPageForCreator: number = 0;
  endPageForCreator: number;
  pagesForCreator: number[];
  creatorList: CreatorList[];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private commonService: CommonService,
  ) {}

  ngOnInit(): void {
    this.commonService.creatorlist.subscribe(data => {
      this.creatorList = data;
      [this.endPageForCreator, this.pagesForCreator] = this.calcForPagenation(data);
    });
    if(this.route.snapshot.queryParamMap.get('page')){
      this.pagerForCreator(Number(this.route.snapshot.queryParamMap.get('page')) -1 ) //page index starts from 0
    }
  }

  /**
   * 配信者一覧のページ遷移処理
   * @param page 
   */
  pagerForCreator(selectedPage: number): void {
    this.currentPageForCreator = this.maxDisplayCount * selectedPage;
    // 総ページ数が5ページより多い場合のみセンタリング処理を行う
    if (this.endPageForCreator > 5) {
      let pageChangeResult = this.changeDisplayPagination(selectedPage, this.endPageForCreator);
      if (pageChangeResult !== "NO_CHANGE") {
        this.pagesForCreator = pageChangeResult;
      }
    }
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        page: selectedPage + 1
      }
    });
  }

  /**
   * ① 「<<」が押下された場合は1-5ページを表示する
   * ② 1~3ページが押下された場合はセンター寄せせず表示する
   * ③ 「>>」が押下された場合は最後の5ページ分を表示する
   * ④ 最後の3ページが押下された場合はセンター寄せせず表示する
   * ⑤ ①〜④以外はセンター寄せにして表示する
   * @param selectedPage 
   * @param endPage 
   */
  private changeDisplayPagination(selectedPage: number, endPage: number): number[] | "NO_CHANGE" {
    const endingStartPage = endPage - 5;

    if (selectedPage === 0) { // ①
      return Array.from({ length: this.maxDisplayPage }).map((_: undefined, i: number) => i);
    } else if (selectedPage === 1) {
      return Array.from({ length: this.maxDisplayPage }).map((_: undefined, i: number) => i);
    } else if (selectedPage < this.beginingStartPage) { // ②
      return "NO_CHANGE";
    } else if (selectedPage === endPage - 1 || selectedPage === endPage - 2) { // ③
      return Array.from({ length: this.maxDisplayPage }).map((_: undefined, i: number) => i + endingStartPage);
    } else if (endPage - 2 <= selectedPage && selectedPage <= endPage) { // ④
      return "NO_CHANGE";
    } else { // ⑤
      return Array.from({ length: this.maxDisplayPage }).map((_: undefined, i: number) => i + selectedPage - 2);
    }
  }

  /**
   * magazineIdでフィルタした配信リストを表示する
   * @param magazineId 
   */
  showVideoListForCreator(magazineId: number): void {
    this.router.navigate([magazineId + '/lives'], { relativeTo: this.route });
  }

  /**
   * ページネーションカウント算出
   * @param data
   */
  private calcForPagenation(data: Array<any>): [number, []] {
    let displayPage = 0;
    let pages;
    let endPage: number;

    endPage = Math.ceil(data.length / this.maxDisplayCount);
    if (endPage > this.maxDisplayPage) {
      displayPage = this.maxDisplayPage;
    } else {
      displayPage = endPage;
    }
    pages = Array.from({ length: displayPage }).map((_: undefined, i: number) => i);
    return [endPage, pages];
  }
}
